import HierarchyFilterHelper from "@/utils/common/HierarchyFilterHelper.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import DomainBaseFieldIDs from "@/utils/constants/DomainBaseFieldIDs.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import EntityTypesUtils from "@/utils/common/EntityTypesUtils.ts";
import ACCEntities from "@/utils/constants/ACCEntities.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import IdsAndConstants from "@/utils/UIConstants/IdsAndConstants.ts";

export default class CommonEntityViewCustomizer {
  static GROUP_FILTER_HELPER: HierarchyFilterHelper = new HierarchyFilterHelper("group." + CommonFieldIds.FULL_HIERARCHY_PATH);
  static PARENT_FILTER_HELPER: HierarchyFilterHelper = new HierarchyFilterHelper(CommonFieldIds.HIERARCHY_PATH);
  static DmsDOCUMENT_FILTER_HELPER: HierarchyFilterHelper = new HierarchyFilterHelper("parent." + CommonFieldIds.FULL_HIERARCHY_PATH);
  static ACCOUNT_CHART_WHEN_DEBIT_FILTER_HELPER: HierarchyFilterHelper = new HierarchyFilterHelper(DomainBaseFieldIDs.Account_chartWhenDebit + "." + CommonFieldIds.FULL_HIERARCHY_PATH);
  static AU_PROCEDURES_AND_TEST_FILTER_HELPER: HierarchyFilterHelper = new HierarchyFilterHelper(DomainBaseFieldIDs.AUTestDef_phase + "." + DomainBaseFieldIDs.AUPhase_fullHierarchyPath);
  static REMARK_TYPE_FILTER_HELPER: HierarchyFilterHelper = new HierarchyFilterHelper("remarkType." + CommonFieldIds.FULL_HIERARCHY_PATH);

  static getHelperForEditView(entityType: string): HierarchyFilterHelper | undefined {
    if (NamaCommon.hasParentEntity(entityType))
      return CommonEntityViewCustomizer.PARENT_FILTER_HELPER;
    if (EntityTypesUtils.isMaster(entityType))
      return CommonEntityViewCustomizer.GROUP_FILTER_HELPER;
    return undefined;
  }

  static getHelperForListView(entityType: string): HierarchyFilterHelper | undefined {
    if (ACCEntities.Account === entityType)
      return CommonEntityViewCustomizer.ACCOUNT_CHART_WHEN_DEBIT_FILTER_HELPER;
    if (BSCEntities.Remark === entityType)
      return CommonEntityViewCustomizer.REMARK_TYPE_FILTER_HELPER;
    if (BSCEntities.DetailedRemark === entityType)
      return CommonEntityViewCustomizer.REMARK_TYPE_FILTER_HELPER;
    if (BSCEntities.DMSDocument === entityType)
      return CommonEntityViewCustomizer.DmsDOCUMENT_FILTER_HELPER;
    if (ObjectChecker.isAnyEqualToFirst(entityType, IdsAndConstants.AUTestDef))
      return CommonEntityViewCustomizer.AU_PROCEDURES_AND_TEST_FILTER_HELPER;
    if (NamaCommon.hasParentEntity(entityType))
      return CommonEntityViewCustomizer.PARENT_FILTER_HELPER;
    if (EntityTypesUtils.isMaster(entityType))
      return CommonEntityViewCustomizer.GROUP_FILTER_HELPER;
    return undefined;
  }
}
